import { render, staticRenderFns } from "./PageDevTool.vue?vue&type=template&id=34d1236f&scoped=true&"
import script from "./PageDevTool.vue?vue&type=script&lang=js&"
export * from "./PageDevTool.vue?vue&type=script&lang=js&"
import style0 from "./PageDevTool.vue?vue&type=style&index=0&id=34d1236f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d1236f",
  null
  
)

export default component.exports